/**
 * Created by jack.gill on 21/11/2017.
 */
var JumpGameCollectible = function (collectiblesArray) {
    PIXI.Container.call(this);
    this.collectiblesArray = collectiblesArray;
    this.visible = false;
    this.canBeCollected = false;
    this.points = 0;
    this.graphic = CC.Utility.pixiSprite(this.collectiblesArray[0].texture);
    this.addChild(this.graphic);
};

JumpGameCollectible.prototype = Object.create(PIXI.Container.prototype);
JumpGameCollectible.prototype.constructor = JumpGameCollectible;

JumpGameCollectible.prototype.checkHit = function (player) {
    var testDistance = CC.Geometry.vectorDistanceSquared(player, this);
    return testDistance < 50 * 50 && this.canBeCollected;
};

JumpGameCollectible.prototype.collect = function () {
    this.canBeCollected = false;
    TweenLite.to(this.graphic, 0.2, {alpha: 0});
    TweenLite.to(this.graphic.scale, 0.2, {x: 2, y: 2, onComplete: this.hide.bind(this)});
};

JumpGameCollectible.prototype.show = function (platform, type) {
    TweenLite.killTweensOf(this.graphic);
    this.type = type;
    this.graphic.alpha = 1;
    this.canBeCollected = true;
    this.graphic.scale.x = 1;
    this.graphic.scale.y = 1;

    this.extraLife = this.collectiblesArray[this.type].extra_life;

    this.boostDistance = this.collectiblesArray[this.type].boost_distance;
    this.boostTime = this.collectiblesArray[this.type].boost_time;

    this.invincibleTime = this.collectiblesArray[this.type].invincible_time;

    this.graphic.texture = PIXI.Texture.fromFrame(this.collectiblesArray[this.type].texture);
    if (this.sparkles) {
        this.removeChild(this.sparkles);
    }
    if (this.collectiblesArray[this.type].sparkles) {
        this.sparkles = Widgets.createAsset(this.collectiblesArray[this.type].sparkles);
        this.addChild(this.sparkles);
        this.sparkles.gotoAndPlay(0);
    }
    this.visible = true;
    this.targetPlatform = platform;
    this.x = this.targetPlatform.x;
    this.halfHeight = this.height / 2;
    this.y = this.targetPlatform.y - this.targetPlatform.halfHeight;

};

JumpGameCollectible.prototype.hide = function () {
    this.graphic.alpha = 1;
    this.visible = false;
    this.canBeCollected = false;
};